import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
function InsightsBanner() {
  return (
    <section 
      className="relative py-40 lg:py-28 overflow-hidden bg-fixed bg-center bg-cover bg-no-repeat"
      style={{
        backgroundImage: `url('https://img.magnific.com/free-photo/happy-businesswoman-holding-folder_74855-5075.jpg?semt=ais_hybrid&w=740&q=80')`
      }}
    >
      {/* Overlay gradient for text readability */}
      <div className="absolute inset-0 bg-gradient-to-t from-cogInk via-cogInk/90 to-cogInk/50" />
      
      <div className="relative max-w-3xl mx-auto text-center px-6 z-10">
       <h3 className="text-white text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight mb-4">
  Powering Precision in Wire Harness Manufacturing
</h3>

<p className="text-gray-200 text-lg lg:text-xl font-light mb-8 leading-relaxed max-w-2xl mx-auto">
  From custom design to full-scale assembly, we deliver high-reliability wiring harnesses built to perform in the most demanding environments. Partner with us to power your next system.
</p>
     <Link
  to="/contact"
  className="group bg-cyan-400 text-cogBrand font-bold px-8 py-4 rounded-full inline-flex items-center justify-center gap-2 hover:bg-cyan-300 hover:scale-105 active:scale-95 transition-all duration-300 text-sm sm:text-base tracking-wide shadow-lg shadow-cyan-400/20"
>
  <span>Explore Open Roles</span>
  <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.5} />
</Link>
      </div>
    </section>
  );
}

export default InsightsBanner;